"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getShellRoutes;
exports.getShellRoutesArray = getShellRoutesArray;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _NuiPageContainer = _interopRequireDefault(require("../containers/NuiPageContainer"));
var _Errors = require("../components/Errors");
var _createRoutesFromChildren = _interopRequireDefault(require("./createRoutesFromChildren"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return shell routes that every app needs
function getShellRoutes() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var useAnonymousErrorRoutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shellRoutes = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    element: /*#__PURE__*/_react.default.createElement(_NuiPageContainer.default, null)
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(baseUrl, "/serverError"),
    element: /*#__PURE__*/_react.default.createElement(_Errors.ServerError, null),
    status: 500,
    isAnonymous: useAnonymousErrorRoutes
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(baseUrl, "/forbidden"),
    element: /*#__PURE__*/_react.default.createElement(_Errors.Forbidden, null),
    status: 403,
    isAnonymous: useAnonymousErrorRoutes
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(baseUrl, "/*"),
    element: /*#__PURE__*/_react.default.createElement(_Errors.NotFound, null),
    status: 404,
    isAnonymous: useAnonymousErrorRoutes
  }));
  return shellRoutes;
}

// Return shell routes in a route object array
function getShellRoutesArray() {
  var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var useAnonymousErrorRoutes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var shellRoutes = getShellRoutes(baseUrl, useAnonymousErrorRoutes);
  return (0, _createRoutesFromChildren.default)(shellRoutes);
}